import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { ObserverService } from 'src/app/services/observer.service';
import { CartService } from 'src/app/services/cart.service';
import { PricingTierService } from 'src/app/services/pricing-tier.service';

@Component({
    selector: 'app-cart-pricing-tier',
    templateUrl: './cart-pricing-tier.page.html',
    styleUrls: ['./cart-pricing-tier.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CartPricingTierPage implements OnInit {

    pricing_tiers = null;
    selected_pricing_tier_id = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private observerService: ObserverService,
        private cartService: CartService,
        private pricingTierService: PricingTierService,

    ) { }

    ngOnInit() {
        
        this.cartService.get().then((cart) => {
            this.selected_pricing_tier_id = cart['pricing_tier'].id;
        });

        this.pricingTierService.getPricingTiers().then((pricing_tiers) => {
            if (pricing_tiers) {
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_added|cart_pricing_tier_modal', (pricing_tier) => {
            if (pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                pricing_tiers.push(pricing_tier);
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_updated|cart_pricing_tier_modal', (pricing_tier) => {
            if (pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for (let i = 0; i < pricing_tiers.length; i++) {
                    if (pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers[i] = pricing_tier;
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_deleted|cart_pricing_tier_modal', (pricing_tier) => {
            if (pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for (let i = 0; i < pricing_tiers.length; i++) {
                    if (pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers.splice(i, 1);
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tiers_changed|cart_pricing_tier_modal', (pricing_tiers) => {
            if (pricing_tiers) {
                this.sortPricingTiers(pricing_tiers);
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("pricing_tier_added|cart_pricing_tier_modal");
        this.observerService.destroy("pricing_tier_updated|cart_pricing_tier_modal");
		this.observerService.destroy("pricing_tier_deleted|cart_pricing_tier_modal");
        this.observerService.destroy("pricing_tiers_changed|cart_pricing_tier_modal");
    }

    close() {
        this.modalController.dismiss();
    }

    sortPricingTiers(pricing_tiers) {
        pricing_tiers.sort((a, b) => {
            if (a['order'] < b['order']) { return -1; }
            if (a['order'] > b['order']) { return 1; }
            return 0;
        });
        this.pricing_tiers = pricing_tiers;
    }

    update() {
        for (let i = 0; i < this.pricing_tiers.length; i++) {
            if (this.pricing_tiers[i].id === this.selected_pricing_tier_id) {
                this.cartService.updatePricingTier(this.pricing_tiers[i])
                .catch((error) => {
                    // alert?
                });
                break;
            }
        }
        this.modalController.dismiss();
    }

}
